(function () {
	const ROOT = ".js-product-markers-slider";
	const SLIDE = ".product-markers__slide";
	const MARKER = ".js-product-markers__item";
	const CARD = ".js-product-markers__card";
	const MOBILE = ".js-product-markers__mobile";
	const MOBILE_CARD = ".js-product-markers__item-inner";

	const closestMarker = (target) =>
		target instanceof Element ? target.closest(MARKER) : null;

	const indexMarkers = (slide) => {
		slide
			.querySelectorAll(MARKER)
			.forEach((marker, index) => (marker.dataset.index = String(index + 1)));
	};

	const currentSlide = (root) =>
		root.querySelector(".swiper-slide-active") || root.querySelector(SLIDE);

	// Nested theme blocks can't be looped over in Liquid, so the mobile card list is
	// cloned from the markers of whichever slide is showing.
	const renderMobileCards = (root, slide) => {
		const mobile = root.querySelector(MOBILE);
		if (!mobile || !slide) return;

		mobile.innerHTML = "";

		slide.querySelectorAll(MARKER).forEach((marker) => {
			const card = marker.querySelector(CARD);
			if (!card) return;

			const clone = card.cloneNode(true);
			clone.classList.add("js-product-markers__item-inner");
			clone.dataset.index = marker.dataset.index;
			mobile.appendChild(clone);
		});

		// Keep the visible card in step with this slide's selected marker. Without
		// this, CSS falls back to :first-child and contradicts the active marker.
		const active = slide.querySelector(`${MARKER}.active`);
		if (active) {
			mobile.querySelectorAll(MOBILE_CARD).forEach((card) => {
				card.style.display =
					card.dataset.index === active.dataset.index ? "block" : "none";
			});
		}
	};

	const activateMarker = (marker) => {
		const slide = marker.closest(SLIDE);
		const root = marker.closest(ROOT);
		if (!slide || !root) return;

		slide
			.querySelectorAll(MARKER)
			.forEach((item) => item.classList.toggle("active", item === marker));

		const mobile = root.querySelector(MOBILE);
		if (mobile) {
			mobile.querySelectorAll(MOBILE_CARD).forEach((card) => {
				card.style.display =
					card.dataset.index === marker.dataset.index ? "block" : "none";
			});
		}
	};

	// Swiper only treats direct children of the track as slides, so make sure the
	// rendered slide blocks sit there even if they come back wrapped.
	const normalizeSlides = (root) => {
		const track = root.querySelector(".swiper-wrapper");
		if (!track) return;

		root.querySelectorAll(SLIDE).forEach((slide) => {
			if (slide.parentElement !== track) track.appendChild(slide);
		});
	};

	// Slide index + marker for the current product (or, on a modular PDP, any of its
	// child products). Handles come from data-match-handles, set in Liquid.
	const findMatch = (root, slides) => {
		const handles = (root.dataset.matchHandles || "").split(",").filter(Boolean);
		if (!handles.length) return null;

		for (let i = 0; i < slides.length; i++) {
			const marker = Array.prototype.find.call(
				slides[i].querySelectorAll(MARKER),
				(item) => handles.indexOf(item.dataset.productHandle) !== -1
			);
			if (marker) return { index: i, marker };
		}
		return null;
	};

	const initSwiper = (root, initialSlide) => {
		const container = root.querySelector(".product-markers__swiper");
		if (!container || typeof Swiper === "undefined") return null;

		const autoplay = root.dataset.autoplay === "true";
		const speed = parseFloat(root.dataset.speed) || 0.6;
		const delay = parseFloat(root.dataset.delay) || 5;

		return new Swiper(container, {
			slidesPerView: 1,
			initialSlide: initialSlide || 0,
			speed: speed * 1000,
			loop: root.dataset.loop === "true",
			autoHeight: true,
			watchOverflow: true,
			keyboard: true,
			navigation: {
				prevEl: root.querySelector(".js-product-markers__prev"),
				nextEl: root.querySelector(".js-product-markers__next"),
			},
			pagination: {
				el: root.querySelector(".js-product-markers__pagination"),
				clickable: true,
			},
			autoplay: autoplay
				? {
						delay: delay * 1000,
						pauseOnMouseEnter: root.dataset.stopAutoplay === "true",
						disableOnInteraction: false,
				  }
				: false,
		});
	};

	const initSection = (root) => {
		if (root.classList.contains("markers_slider_started")) return;
		root.classList.add("markers_slider_started");

		normalizeSlides(root);

		const slides = root.querySelectorAll(SLIDE);
		const openFirst = root.dataset.defaultActiveFirst === "true";

		const match = findMatch(root, slides);

		slides.forEach((slide) => {
			indexMarkers(slide);

			if (openFirst) {
				const first = slide.querySelector(MARKER);
				if (first) first.classList.add("active");
			}
		});

		// Open on the slide that has the current product (or one of its children),
		// with that product's marker selected.
		if (match) {
			match.marker
				.closest(SLIDE)
				.querySelectorAll(MARKER + ".active")
				.forEach((item) => item.classList.remove("active"));
			match.marker.classList.add("active");
		}

		if (slides.length > 1) {
			root.swiperInstance = initSwiper(root, match ? match.index : 0);

			if (root.swiperInstance) {
				root.swiperInstance.on("slideChange", function () {
					renderMobileCards(root, this.slides[this.activeIndex]);
				});
			}
		} else {
			root.classList.add("product-markers--single");
		}

		renderMobileCards(root, currentSlide(root));

		root.addEventListener("click", (event) => {
			const marker = closestMarker(event.target);
			if (marker) activateMarker(marker);
		});

		// The default-open card closes as soon as a marker is hovered, so hover and
		// click never fight over which card is shown.
		root.addEventListener("mouseover", (event) => {
			const marker = closestMarker(event.target);
			if (!marker || marker.classList.contains("active")) return;

			const slide = marker.closest(SLIDE);
			if (slide) {
				slide
					.querySelectorAll(MARKER + ".active")
					.forEach((item) => item.classList.remove("active"));
			}
		});
	};

	const init = (scope) => {
		const context = scope && scope.querySelectorAll ? scope : document;
		context.querySelectorAll(ROOT).forEach(initSection);
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", () => init(document));
	} else {
		init(document);
	}

	document.addEventListener("shopify:section:load", (event) =>
		init(event.target)
	);

	document.addEventListener("shopify:section:unload", (event) => {
		event.target.querySelectorAll(ROOT).forEach((root) => {
			if (root.swiperInstance) root.swiperInstance.destroy(true, true);
		});
	});

	document.addEventListener("shopify:block:select", (event) => {
		const block = event.target;
		const root = block.closest(ROOT);
		if (!root) return;

		const swiper = root.swiperInstance;
		const slide = block.closest(SLIDE);

		if (slide && swiper) {
			const originals = root.querySelectorAll(
				SLIDE + ":not(.swiper-slide-duplicate)"
			);
			const index = Array.prototype.indexOf.call(originals, slide);

			if (index >= 0) {
				if (swiper.params.loop) {
					swiper.slideToLoop(index);
				} else {
					swiper.slideTo(index);
				}
			}
		}

		if (block.classList.contains("js-product-markers__item")) {
			activateMarker(block);
		}
	});
})();
